<template>

    <div class="profile text-center">
        <div class="bg">
            <div class="profile-avatar"
                 :style="`background-image: url(${user.avatar || defaultAvatar});`"/>
                {{user.info.name}} {{user.info.surname}}
            <br/>
            <btn @press="changeAvatar" label="Изменить аватар" icon="image" type="success" size="large"/>
        </div>


        <panel title="Информация">
            <table style='width:100%;'>
                <tbody>
                    <tr>
                        <td>ID пользователя</td>
                        <td>{{user._id}}</td>
                    </tr>
                    <tr>
                        <td>Дата регистрации</td>
                        <td>{{regDate | date('DD MMMM YYYY год')}}</td>
                    </tr>
                    <tr>
                        <td>Телефон</td>
                        <td>{{user.phone || "Телефон не указан"}}</td>
                    </tr>
                    <tr>
                        <td>Email</td>
                        <td>{{user.email || "Email не указан" }}</td>
                    </tr>
                    <tr>
                        <td>Баланс</td>
                        <td>{{user.credit}} тенге</td>
                    </tr>
                </tbody>
            </table>
        </panel>

        <panel title="Изменить учетную запись">
            <inputi label="Имя" :value="user.info.name" @input="(v)=>{changeInfo('name',v)}"/>
            <inputi label="Фамилия" :value="user.info.surname" @input="(v)=>{changeInfo('surname',v)}"/>
            <btn :disabled="!infoChanged" @press="saveInfo" label="Сохранить изменения" t='p' s='m' i='check' iR/>
        </panel>
        <panel title="Настройка телефона">
            <inputi label="Телефон" :value="user.phone"  @input="(v)=>{phone = v}" placeholder="например +77771234567"/>
            <btn :disabled="phone==user.phone" l="Подтвердить" t='p' s='m' i='check' iR @press="savePhone"/>
        </panel>
        <panel title="Настройка email">
            <inputi label="Email" v-model="email"/>
            <btn @press="changeEmail" label="Подтвердить" t='p' s='m' i='check' iR/>
        </panel>
        <panel title="Изменить пароль">
            <inputi type="password" label="Старый пароль" v-model="password"/>
            <inputi type="password" label="Новый пароль" v-model="newPassword"/>
            <inputi type="password" label="Введите повторно" v-model="newPasswordRepeat"/>
            <btn @press="changePassword" label="Изменить пароль" t='p' s='m' i='lock' iR/>
        </panel>
            
    </div>
    </div>

</template>
<script>
    export default {
        name: "i-profile",
        components: {},
        props: [],
        methods: {
            changeInfo(key,value){
                this.infoChanged = true;
                this[key] = value;
            },
            saveInfo(){
                let {name,surname} = this;
                this.$store.dispatch('saveInfo',_.pickBy({name,surname}, _.identity));
                this.infoChanged = false;
            },
            savePhone(){
                this.$store.dispatch('savePhone',this.phone);
            },
            changePassword(){},
            changeEmail(){},
            changeAvatar(){},
        },
        data() {
            return {
                defaultAvatar:require('../../assets/img/avatar.svg'),
                categoryEditModal: false,
                infoChanged:false,
                item: "value",
                phone: '',
                email: '',
                id: 1,
                regDate: new Date(),
                name: '',
                surname: "",
                password: '',
                newPassword: '',
                newPasswordRepeat: '',
            }
        },
        mounted(){
            this.phone = this.user.phone;
        },
        computed: {
            user() {
                return this.$store.state.profile.user;
            },
            cities(){
                return this.$store.state.cities.map((city)=>{
                    return {label:city.name, value:city.code};
                });
            }
        }
    }
</script>
<style scoped>
    .panel-holder {
        columns: 2;
        -webkit-columns: 2;
        column-gap: 0;
        padding: 12px;
    }

    @media (max-width: 930px) {
        .panel-holder {
            columns: 1;
        }
    }

    @media (min-width: 1230px) {
        .panel-holder {
            columns: 3;
        }
    }

    .bg {
        background-image: url(http://app.landos.kz/assets/img/profile.jpg);
        background-size: cover;
        background-position: center;
        padding: 10px;
        text-align: center;
        color: white;
        font-size: 24px;

    }

    .profile-avatar {
        background-image: url(http://avtopoisk.kz/assets/img/profile.png);
        background-color: #fff;
        background-size: cover;
        background-position: center;
        margin: auto;
        width: 150px;
        height: 150px;
        border: 8px solid #fff;
        border-radius: 100%;
        padding: 10px;
    }

    table {
        margin: 10px auto;
    }

    td:first-child {
        text-align: left;
        padding-right: 40px;
    }

    td:nth-child(2) {
        text-align: right;
    }

    td {
        border-bottom: 1px solid lightgrey;
        padding: 4px;
    }

    .categories {
        width: 100%;

        display: block;
        border: 1px solid lightgrey;
        border-radius: 4px;
        padding: 4px;
        max-height: 120px;
    }
</style>